module.exports = __webpack_public_path__ + "img/openvpn.7fd181e7.png";